import { render, staticRenderFns } from "./questionTopic.vue?vue&type=template&id=693945d4&scoped=true"
import script from "./questionTopic.vue?vue&type=script&lang=js"
export * from "./questionTopic.vue?vue&type=script&lang=js"
import style0 from "./questionTopic.vue?vue&type=style&index=0&id=693945d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693945d4",
  null
  
)

export default component.exports